let min = 80

let css_var = document.querySelector('body')


function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}
  

export default {
    parseHueToRGB:function(color, bright, sat){
        let switch_off_color = this.hexToRgb(css_var.style.getPropertyValue('--switch_off_color'));
        if (switch_off_color) min = Math.round((switch_off_color.r + switch_off_color.g + switch_off_color.b)/5)
        let r = 0
        let g = 0
        let b = 0
        sat = (100 - sat)*0.5
        if (color<34) {
            r = Math.round(min+((33 - color)*(255-min)/33) * bright/100)
            g = Math.round(min+(color*(255-min)/33) * bright/100)
            b = min
        }
        else if (color<67) {
            r = min
            g = Math.round(min+((66 - color)*(255-min)/33)*bright/100)
            b = Math.round(min+((color - 33)*(255-min)/33)*bright/100)
        }
        else {
            r = Math.round(min+((color - 66)*(255-min)/33)*bright/100)
            g = min
            b = Math.round(min+((100 - color)*(255-min)/33)*bright/100)
        }
        
        let out_r = Math.round((r + sat*g/100 + sat*b/100)/(1+sat/100))
        let out_g = Math.round((g + sat*r/100 + sat*b/100)/(1+sat/100))
        let out_b = Math.round((b + sat*g/100 + sat*r/100)/(1+sat/100))

        return 'rgb('+out_r+','+out_g+','+out_b+')'
    },

    updateRgbSliderStyle:function(color){
        let r = 0
        let g = 0
        let b = 0
        if (color<33) {
            r = Math.round((33 - color)*255/33)
            g = Math.round(color*255/33)
            b = 0
        }
        else if (color<66) {
            r = 0
            g = Math.round((66 - color)*255/33)
            b = Math.round((color - 33)*255/33)
        }
        else {
            r = Math.round((color - 66)*255/33)
            g = 0
            b = Math.round((100 - color)*255/33)
        }
        return ('rgb('+r+','+g+','+b+')')
    },

    parseWcToRGB:function(color, bright){
        let switch_off_color = this.hexToRgb(css_var.style.getPropertyValue('--switch_off_color'));
        if (switch_off_color) min = Math.round((switch_off_color.r + switch_off_color.g + switch_off_color.b)/6)
        let r = 0
        let g = 0
        let b = 0
        if (color<51) {
            b = 255
            r = Math.round((color)*255/50)
            g = Math.round((r / 2) + 125)
        }
        else if (color<101) {
            b = Math.round((100 - color)*255/50)
            r = 255
            g = r
        }
        r = min + r*(255-min)/255*bright/120
        g = min + g*(255-min)/255*bright/120
        b = min + b*(255-min)/255*bright/120

        return 'rgb('+r+','+g+','+b+')'
    },

    updateWcSliderStyle:function(color){
        let r = 0
        let g = 0
        let b = 0
        if (color<51) {
            r = Math.round((color)*225/50 + 30)
            g = Math.round((color)*82/50 + 173)
            b = 255
        }
        else if (color<101) {
            r = 255
            g = Math.round((100 - color)*22/50 + 233)
            b = Math.round((100 - color)*225/50 + 30)
        }
        return ('rgb('+r+','+g+','+b+')')
    },

    parseDimmerToRGB:function(bright){
        
        let switch_off_color = this.hexToRgb(css_var.style.getPropertyValue('--switch_off_color'));
        let switch_on_color = this.hexToRgb(css_var.style.getPropertyValue('--switch_on_color'));
        
        let r_off = switch_off_color.r;
        let g_off = switch_off_color.g;
        let b_off = switch_off_color.b;
        let r_on = switch_on_color.r;
        let g_on = switch_on_color.g;
        let b_on = switch_on_color.b;
        
        let r = Math.round(((parseInt(bright) + 50) * (r_on - r_off) / 150) + r_off)
        let g = Math.round(((parseInt(bright) + 50) * (g_on - g_off) / 150) + g_off)
        let b = Math.round(((parseInt(bright) + 50) * (b_on - b_off) / 150) + b_off)

        return 'rgb('+r+','+g+','+b+')'
    },

    rgbToHex:function (r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },

    hexToRgb:function(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
    }
}